import { render, staticRenderFns } from "./TabWires.vue?vue&type=template&id=2378d5ea&"
import script from "./TabWires.vue?vue&type=script&lang=js&"
export * from "./TabWires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports